import styled from 'styled-components/macro';

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.textNegative};
`;
